"use client";

import type { SignUpPopoverProps } from "@ui/components/core/SignUpPopover";

import { SignUpPopover } from "@ui/components/core/SignUpPopover";
import { SoundEffectsPopoverCover } from "@ui/components/sound-effects/SoundEffectsPopoverCover";
import IconStar from "@ui/central-icons/icons/IconStar";
import IconArrowInbox from "@ui/central-icons/icons/IconArrowInbox";
import IconSoundFx from "@ui/central-icons/icons/IconSoundFx";
import { iconStrokeFix } from "@ui/central-icons/iconUtils";
import { cn } from "@ui/lib/utils";
import { useTranslations } from "next-intl";

import weatherCover from "./images/weather.png";

interface SfxSignUpPopoverSectionProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  ctaText: string;
  ctaHref: string;
  features: [string, ...string[]];
  ctaEventName?: SignUpPopoverProps["ctaEventName"];
}

export function SfxSignUpPopoverSection({
  isOpen,
  onOpenChange,
  title,
  ctaText,
  ctaHref,
  features,
  ctaEventName,
}: SfxSignUpPopoverSectionProps) {
  const t = useTranslations("ClientKeys.SoundEffectCategories.popover");

  const featureItems: [{ icon: React.ReactNode; text: string }, ...{ icon: React.ReactNode; text: string }[]] = [
    { icon: <IconSoundFx className={cn(iconStrokeFix, "tw-size-[18px]")} />, text: features[0] },
    { icon: <IconStar className={cn(iconStrokeFix, "tw-size-[18px]")} />, text: features[1] },
    { icon: <IconArrowInbox className={cn(iconStrokeFix, "tw-size-[18px]")} />, text: features[2] },
  ];

  return (
    <SignUpPopover
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      cover={
        <SoundEffectsPopoverCover
          categoryName={t("weather")}
          categoryImageUrl={weatherCover.src}
          activeTrackTitle={t("activeTrackTitle")}
          inactiveTrackTitle={t("inactiveTrackTitle")}
        />
      }
      title={title}
      featureItems={featureItems}
      ctaText={ctaText}
      ctaHref={ctaHref}
      ctaEventName={ctaEventName}
    />
  );
}
